import { differenceInMinutes as differenceInMinutesFns } from 'date-fns';

export default function differenceInMinutes(
  dateLeft: Date,
  dateRight: Date,
): number {
  return differenceInMinutesFns(dateLeft, dateRight);
}
